import addFileIcon from './addFileIcon.svg'
import sendIcon from './send.svg'
import smileIcon from './smileIcon.svg'

export { addFileIcon, smileIcon, sendIcon }
